import React from "react";

const CaseStudiesHero: React.FC = () => {
  return (
    <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:pl-8">
              <h2 className="text-5xl lg:text-6xl font-light leading-tight mb-6">
                Real businesses,
                <br />
                <span className="text-gray-500">real results.</span>
              </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              See how we've helped companies automate their most time-consuming
              workflows and deliver measurable impact in weeks, not months.
            </p>

            <a
              href="https://calendly.com/rohansontakke/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors inline-block"
            >
              Book a free call
            </a>
          </div>

          {/* Right Visual - Flower Image Placeholder */}
          <div className="relative">
            <div className="rounded-3xl h-80 md:h-96 relative overflow-hidden bg-transparent flex items-center justify-center p-4">
              <img
                src="/ChatGPT%20Image%20Nov%2025,%202025,%2008_21_34%20PM.png"
                alt="Softly painted sunflower"
                className="max-h-full max-w-full object-contain drop-shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesHero;
